export const ALWAN_CLASSNAME = 'alwan';
export const CONTAINER_CLASSNAME = `${ALWAN_CLASSNAME}__container`;
export const PALETTE_CLASSNAME = `${ALWAN_CLASSNAME}__palette`;
export const MARKER_CLASSNAME = `${ALWAN_CLASSNAME}__marker`;
export const PREVIEW_CLASSNAME = `${ALWAN_CLASSNAME}__preview`;
export const BUTTON_CLASSNAME = `${ALWAN_CLASSNAME}__button`;
export const COPY_BUTTON_CLASSNAME = `${ALWAN_CLASSNAME}__copy-button`;
export const SLIDER_CLASSNAME = `${ALWAN_CLASSNAME}__slider`;
export const SLIDERS_CLASSNAME = `${ALWAN_CLASSNAME}__sliders`;
export const HUE_SLIDER_CLASSNAME = `${ALWAN_CLASSNAME}__slider--hue`;
export const ALPHA_SLIDER_CLASSNAME = `${ALWAN_CLASSNAME}__slider--alpha`;
export const INPUT_CLASSNAME = `${ALWAN_CLASSNAME}__input`;
export const INPUTS_CLASSNAME = `${ALWAN_CLASSNAME}__inputs`;
export const SWATCH_CLASSNAME = `${ALWAN_CLASSNAME}__swatch`;
export const SWATCHES_CLASSNAME = `${ALWAN_CLASSNAME}__swatches`;
export const PRESET_BUTTON_CLASSNAME = `${ALWAN_CLASSNAME}__preset-button`;
export const BACKDROP_CLASSNAME = `${ALWAN_CLASSNAME}__backdrop`;
export const COLLAPSE_BUTTON_CLASSNAME = `${ALWAN_CLASSNAME}__toggle-button`;

export const POPUP_CLASSNAME = `${ALWAN_CLASSNAME}--popup`;
export const OPEN_CLASSNAME = `${ALWAN_CLASSNAME}--open`;
export const COLLAPSE_CLASSNAME = `${ALWAN_CLASSNAME}--collapse`;